
<style scoped lang="scss">
@import '~@/assets/styles/general';
@import '~@/assets/styles/theme';
// $font_size: 1.2rem;
$font_size: 20px;
$base_align: -15%;

.globalNav {}
.globalNav_container {
  @extend .t-moon;
  border-top: 1px solid #6A6A6A;
  opacity: 0.9;

  position: fixed;
  bottom: 0;
  padding: 0.6rem;
  z-index: 2; // temp

  font-size: $font_size;
  line-height: $font_size;
  vertical-align: middle;

  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  // >* {
  //   &:first-child {
  //     color: blue;
  //     margin-right: auto;
  //   }
  // }
}

.globalNav_links {
  margin-right: auto; //全体を右寄せ
  display: flex;
  > li {
    @extend .neutralize-anchor;
    @extend .t-moon--skelton-h;
    padding: 0.2rem;
    margin-left: 0.4rem;
    transition: all ease 0.2s;
  }
}

.globalNav_options {
  // width: 100%;
  // overflow: hidden;
  // text-align: right;
  // position: relative;
  display: flex;
  justify-content: flex-end;

  li {
    display: flex;
    // flex-basis: 48%;
    // vertical-align: middle;
    // align-items: center;
    // align-items: baseline;
    // align-self: center;
    margin-left: 0.6rem;
    cursor: pointer;
    span {
      margin-left: 4px;
    }
  }
  i {
    font-family: 'Material Icons';
    transition: all 0.2s;
    font-size: $font_size*1.4;
    vertical-align: $base_align*1.4;
    &:hover {
      @extend .t-white-s;
    }
  }
}
</style>

<template lang="pug">
.globalNav
  nav.globalNav_container
    ul.globalNav_links
      li(
        v-for="(item, index) in $router.options.routes"
        v-if="item.label"
      )
        router-link(:to="item.path") {{item.label}}
    ul.globalNav_options
      li
        i.material-icons(
          @click="openUserOption"
        ) settings

  animatingModal(
    title="GAME OPTION"
    :isActive="isUserOptionOpen"
    @closed="closeUserOption"
  )
    userOptionForm
</template>

<script>
import switchButton from '@/components/sub/SwitchButton';
import animatingModal from '@/components/sub/AnimatingModal';
import userOptionForm from '@/components/UserOptionForm';

export default {
  name: 'globalNav',
  components: {
    switchButton,
    animatingModal,
    userOptionForm,
  },
  data () {
    return {
      isUserOptionOpen: false,
      // isUserOptionOpen: true,
    }
  },

  methods: {
    openUserOption(e) {
      this.isUserOptionOpen = true;
    },
    closeUserOption(e) {
      this.isUserOptionOpen = false;
    }
  },

  // created() {
    // GameManagerの参照をもたせるとpxb起動中、異様に重くなってしまうので避ける
    // this.pxbGM = pxb.GameManager;
  // },
}
</script>


// WEBPACK FOOTER //
// src/components/GlobalNav.vue